// Generated from the design template (Aithora ConsoleV3.dc.html T17079-17086) by the
// port's converter: every element, inline style string, whitespace run and {{ value }}
// span is the design's own. Values come from the page's vals (see the matching *Vals).
/* eslint-disable @typescript-eslint/no-explicit-any */
import { sx } from '../../ui/designStyles';

export function FpHeadView({ V }: { V: Record<string, any> }) {
  return (
    <>
{' '}<div style={sx("display:flex;align-items:flex-start;gap:16px;flex-wrap:nowrap;min-width:0;")}>{' '}<div style={sx("min-width:0;flex:1 1 auto;")}>{' '}
{V.fpNotHome && (<><h1 style={sx("margin:0;font-size:19px;font-weight:800;letter-spacing:-.02em;line-height:1.2;")}>Family Portal</h1><div title={V.fpLead} style={sx("font-size:16px;color:#54606C;margin-top:4px;max-width:90ch;line-height:1.45;text-wrap:pretty;")} data-testid="fp-lead"><span>{V.fpLead}</span></div></>)}{' '}</div>{' '}<span style={sx("flex:1;")}></span>{' '}<span aria-hidden="true" style={sx("display:inline-flex;height:32px;flex:0 0 auto;")}></span>{' '}</div>
    </>
  );
}
